import {
  SearchCandidateBatchesQueryItem,
  SourcingInternalAnalysisSelectionTableData
} from 'modules/sourcing-internal/tables/types';
import { formatDateFromNowAbbreviated } from 'utils/datetime';
import { getAnalysisTitle } from 'utils/getAnalysisTitle';

export const mapSourcingInternalAnalysisSelectionDataToTableColumns = (
  data: SearchCandidateBatchesQueryItem[]
): SourcingInternalAnalysisSelectionTableData[] => {
  return data.map((item) => ({
    id: item.id,
    jobTitle: getAnalysisTitle(item),
    location: item.jobDescriptionParsed?.location ?? '',
    candidatesCount: item.candidatesCount ?? '-',
    atsJobId: item.atsJobId ?? '-',
    fullName: `${item.user?.firstName ?? ''} ${
      item.user?.lastName ?? ''
    }`.trim(),
    updatedAt: formatDateFromNowAbbreviated(item.updatedAt)
  }));
};
